/* eslint-disable */
import { Grid, TextField, Typography, Box } from "@mui/material";
import { useState, useEffect } from "react";
import { getAreaActual } from "../../services/ProduccionService";
import Message from "../../utils/Message";
//
// ###########################################################################
//
const DatosAreaActual = (props) => {
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [data, setData] = useState({});
  const [mismaAreaActualOrigen, setMismaAreaActualOrigen] = useState(false);
  const [tieneAreaActual, setTieneAreaActual] = useState(false);
  //
  // ################################################################################
  //
  useEffect(() => {
    const loadDatosAreaActual = async () => {
      const response = await getAreaActual(props.anteojoArreglo, props.idGcAnteojoArreglo);
      if (response.ok) {
        let _response = response.data.data;

        if (Object.keys(_response).length !== 0) {
          setData(response.data.data);
          setMismaAreaActualOrigen(
            response.data.data.id_area_actual === response.data.data.id_area_origen ? true : false
          );
          setTieneAreaActual(true);
        }
      } else {
        setMessage({
          severity: response.messageSeverity,
          messageText: response.messageText,
        });
        setShowMessage(true);
        return;
      }
    };
    loadDatosAreaActual();
  }, []);
  //
  // ################################################################################
  //
  return (
    <>
      {tieneAreaActual && (
        <Box
          sx={{
            border: "1px solid LightGrey",
            borderRadius: "5px",
            p: 1,
            mb: 1,
          }}
        >
          <Grid container spacing={1} sx={{ mb: 1 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h6" gutterBottom>
                Área actual
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="descripcion_area_actual"
                label="Área actual"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="descripcion_area_actual"
                value={data.descripcion_area_actual ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="fecha_estado"
                label="Desde el"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="fecha_estado"
                value={data.fecha_estado ?? ""}
                variant="outlined"
              />
            </Grid>

            {!mismaAreaActualOrigen && (
              <Grid item xs={12} sm={6} md={2} lg={2}>
                <TextField
                  id="descripcion_area_origen"
                  label="Área de origen"
                  size="small"
                  sx={{ width: "100%" }}
                  inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                  name="descripcion_area_origen"
                  value={data.descripcion_area_origen ?? ""}
                  variant="outlined"
                />
              </Grid>
            )}

            <Grid item xs={12} sm={6} md={4} lg={4}>
              <TextField
                id="observaciones"
                label="Observacinoes"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="observaciones"
                value={data.observaciones ?? ""}
                variant="outlined"
              />
            </Grid>

            <Grid item xs={12} sm={6} md={2} lg={2}>
              <TextField
                id="usuario_usuario"
                label="Envió"
                size="small"
                sx={{ width: "100%" }}
                inputProps={{ style: { textAlign: "left" }, readOnly: true }}
                name="usuario_usuario"
                value={data.usuario_usuario ?? ""}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </Box>
      )}

      {showMessage && (
        <Message showMessage={showMessage} setShowMessage={setShowMessage} message={message} />
      )}
    </>
  );
};
export default DatosAreaActual;
